const selectStateSlice = (state, sliceKey) => state[sliceKey];
export const buildWithStateSliceSelector = sliceKey => selector => state => selector(selectStateSlice(state, sliceKey));